import ImgTopRelationship from '../../../assets/image/report/img_banner_top_relationship.png';
import ImgMid1 from '../../../assets/image/report/img_banner_middle_1.png';
import ImgMid2 from '../../../assets/image/report/img_banner_middle_2.png';
import ImgBottom from '../../../assets/image/report/img_banner_bottom.png';
import TitleText from '../../common/TitleText';
import DotText from '../../common/DotText';
import Text from '../../common/Text';
import TitleDotText from '../../common/TitleDotText';
import { useTranslation } from '../../../hook/useTranslation';

function Relationship() {
  const { t } = useTranslation();
  return (
    <div className="w-full h-full flex flex-col items-start justify-start gap-[40px]">
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgTopRelationship} alt="top" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.definition')} />
        <Text text={t('report.relationship.definition')} />
      </div>
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgMid1} alt="top" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.behavioral_characteristics', { age: 7 })} />
        <DotText text={t('report.relationship.behavior.1')} />
        <DotText text={t('report.relationship.behavior.2')} />
        <DotText text={t('report.relationship.behavior.3')} />
        <DotText text={t('report.relationship.behavior.4')} />
        <DotText text={t('report.relationship.behavior.5')} />
        <DotText text={t('report.relationship.behavior.6')} />
        <DotText text={t('report.relationship.behavior.7')} />
        <DotText text={t('report.relationship.behavior.8')} />
        <DotText text={t('report.relationship.behavior.9')} />
        <DotText text={t('report.relationship.behavior.10')} />
      </div>
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgMid2} alt="top" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.support_method')} />
        <TitleDotText
          title={t('report.relationship.support.1.title')}
          text={t('report.relationship.support.1.desc')}
        />
        <TitleDotText
          title={t('report.relationship.support.2.title')}
          text={t('report.relationship.support.2.desc')}
        />
        <TitleDotText
          title={t('report.relationship.support.3.title')}
          text={t('report.relationship.support.3.desc')}
        />
        <TitleDotText
          title={t('report.relationship.support.4.title')}
          text={t('report.relationship.support.4.desc')}
        />
        <TitleDotText
          title={t('report.relationship.support.5.title')}
          text={t('report.relationship.support.5.desc')}
        />
        <TitleDotText
          title={t('report.relationship.support.6.title')}
          text={t('report.relationship.support.6.desc')}
        />
      </div>
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgBottom} alt="ImgBottom" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.precautions')} />
        <Text text={t('report.relationship.precautions')} />
      </div>
      <div>&nbsp;</div>
    </div>
  );
}

export default Relationship;
